import { defineComponent as n, openBlock as r, createBlock as l, unref as p, mergeProps as m, withCtx as u, createElementVNode as t } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconLogOut",
  __name: "IconLogOut",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (s, e) => (r(), l(p(c), m(o, { "view-box": "0 0 24 24" }), {
      default: u(() => [...e[0] || (e[0] = [
        t("path", { d: "M6.854 3.25a3.25 3.25 0 0 0-3.25 3.25v11a3.25 3.25 0 0 0 3.25 3.25h2a.75.75 0 0 0 0-1.5h-2a1.75 1.75 0 0 1-1.75-1.75v-11a1.75 1.75 0 0 1 1.75-1.75h2a.75.75 0 0 0 0-1.5h-2" }, null, -1),
        t("path", { d: "M15.323 16.53a.75.75 0 0 1 0-1.06l2.72-2.72h-9.19a.75.75 0 0 1 0-1.5h9.19l-2.72-2.72a.75.75 0 0 1 1.06-1.06l3.647 3.646a1.25 1.25 0 0 1 0 1.768l-3.646 3.646a.75.75 0 0 1-1.06 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
